var Question, W, exportAssessmentSummary, exportConclusions, exportInterventions, exportIsof, exportJustification, exportPopulation, exportQuestionAndRecommendation, get, getCertaintyOfEvidenceAndLabel, getEtdPrintout, getRecommendationDirectionAndStrength, getRecommendationMetadata, getRecommendationMetadataOrUndefined, getRecommendationText, gradeProCodeToWHOCode, mediator, prepareCodes, renderEditorValue, _ref;

get = require('lodash').get;

_ref = require('lib/services/covid_exporter/utils'), exportConclusions = _ref.exportConclusions, exportIsof = _ref.exportIsof, exportJustification = _ref.exportJustification, getCertaintyOfEvidenceAndLabel = _ref.getCertaintyOfEvidenceAndLabel, getEtdPrintout = _ref.getEtdPrintout, getRecommendationDirectionAndStrength = _ref.getRecommendationDirectionAndStrength, getRecommendationMetadata = _ref.getRecommendationMetadata, getRecommendationMetadataOrUndefined = _ref.getRecommendationMetadataOrUndefined, getRecommendationText = _ref.getRecommendationText, gradeProCodeToWHOCode = _ref.gradeProCodeToWHOCode, prepareCodes = _ref.prepareCodes, renderEditorValue = _ref.renderEditorValue;

mediator = require('mediator');

Question = require('models/question');

W = require('when/when');

exportInterventions = function(question) {
  var interventions, _ref1, _ref2, _ref3, _ref4;
  switch (question.type) {
    case 'diagnostic':
      interventions = [
        {
          '@id': '_:int1',
          '@type': 'WHOIntervention',
          'name': question['indexTest'],
          'codes': prepareCodes((_ref1 = get(question, 'codes.indexTest')) != null ? _ref1 : {})
        }
      ];
      if (question['comparatorTestPresent']) {
        interventions.push({
          '@id': '_:int2',
          '@type': 'WHOIntervention',
          'name': question['comparatorTest'],
          'codes': prepareCodes((_ref2 = get(question, 'codes.comparatorTest')) != null ? _ref2 : {})
        });
      }
      return interventions;
    default:
      return [
        {
          '@id': '_:int1',
          '@type': 'WHOIntervention',
          'name': question['intervention'],
          'codes': prepareCodes((_ref3 = get(question, 'codes.intervention')) != null ? _ref3 : {}, {
            '@id': '_:int2',
            '@type': 'WHOIntervention',
            'name': question['comparison'],
            'codes': prepareCodes((_ref4 = get(question, 'codes.comparison')) != null ? _ref4 : {})
          })
        }
      ];
  }
};

exportPopulation = function(question, recommendation) {
  var setting, _ref1;
  setting = renderEditorValue(get(recommendation, 'templateData.question.sections.setting.content'));
  if (!setting) {
    setting = question['settings'];
  }
  if (!setting) {
    setting = void 0;
  }
  return [
    {
      '@id': '_:pop1',
      '@type': 'WHOPopulation',
      'ages': _.reject(getRecommendationMetadata(recommendation, 'age'), function(v) {
        return v === 'any';
      }),
      'codes': prepareCodes((_ref1 = get(question, 'codes.population')) != null ? _ref1 : {}),
      'description': question['healthProblemOrPopulation'],
      'setting': setting
    }
  ];
};

exportAssessmentSummary = function(recommendation) {
  var sections, sectionsOrder, _ref1;
  sectionsOrder = (_ref1 = get(recommendation, 'templateData.assessment.sectionsOrder')) != null ? _ref1 : [];
  sections = _.chain(sectionsOrder).map(function(key) {
    var criterionId, value;
    criterionId = get(recommendation, "templateData.assessment.sections." + key + ".criterionId");
    if (!criterionId) {
      return null;
    }
    value = get(recommendation, "templateData.assessment.criteria." + criterionId + ".selectedOption");
    if ((value == null) || value === '') {
      return null;
    }
    return [key, value];
  }).compact().object().value();
  if (!sections) {
    return void 0;
  }
  return {
    sections: sections,
    sectionsOrder: sectionsOrder
  };
};

exportQuestionAndRecommendation = function(question, recommendations, questionStatuses, projectId) {
  var certaintyOfEvidence, coi, comparison, conclusions, gradeCertaintyOfEvidenceLabel, isDiagnostic, isofData, perspective, presentationStatus, printoutPromise, projectName, questionModel, questionStatus, recommendation, recommendationDirection, recommendationId, recommendationStatus, recommendationStrength, recommendationText, _ref1, _ref2;
  recommendationStatus = get(questionStatuses, "" + question._id + ".recommendationStatus.status");
  if (recommendationStatus !== 'done') {
    return W.resolve();
  }
  projectName = mediator.projects.get(projectId).get('name');
  questionModel = new Question(question);
  isDiagnostic = question['type'] === 'diagnostic';
  recommendationId = _.first(question['recommendationIds']);
  recommendation = get(recommendations, recommendationId);
  if (!recommendation) {
    return W.resolve();
  }
  recommendationText = getRecommendationText(recommendation);
  if (!recommendationText) {
    return W.resolve();
  }
  _ref1 = getRecommendationDirectionAndStrength(recommendation), recommendationDirection = _ref1[0], recommendationStrength = _ref1[1];
  conclusions = exportConclusions(recommendation, ['recommendation', 'goodPracticeStatement']);
  conclusions['sections']['justification'] = exportJustification(recommendation);
  _ref2 = getCertaintyOfEvidenceAndLabel(recommendation), certaintyOfEvidence = _ref2[0], gradeCertaintyOfEvidenceLabel = _ref2[1];
  coi = renderEditorValue(get(recommendation, 'templateData.question.sections.coi.content'));
  if (!coi) {
    coi = void 0;
  }
  perspective = renderEditorValue(get(recommendation, 'templateData.question.sections.perspective.content'));
  if (!perspective) {
    perspective = void 0;
  }
  comparison = question.type === 'diagnostic' && !question.comparatorTestPresent ? void 0 : [
    {
      '@id': '_:int2'
    }
  ];
  questionStatus = get(questionStatuses, "" + question._id + ".evidenceTableStatus.status");
  presentationStatus = get(questionStatuses, "" + question._id + ".presentationStatus.status");
  isofData = questionStatus === 'done' ? exportIsof(questionModel, projectName) : void 0;
  printoutPromise = presentationStatus === 'done' ? getEtdPrintout(projectId, questionModel, recommendationId) : W.resolve(void 0);
  return printoutPromise.then(function(etdPrintout) {
    var siteOfDisease;
    siteOfDisease = getRecommendationMetadata(recommendation, 'siteOfDisease');
    if (siteOfDisease.length === 2) {
      siteOfDisease.push('both');
    }
    return {
      '@id': question['_id'],
      '@type': 'WHORecommendation',
      'intervention': exportInterventions(question),
      'interventionDescription': "" + question['intervention'] + ", " + question['comparison'],
      'population': exportPopulation(question, recommendation),
      'populationDescription': question['healthProblemOrPopulation'],
      'question': [
        {
          '@id': '_:q1',
          '@type': 'WHOQuestion',
          'intervention': [
            {
              '@id': '_:int1'
            }
          ],
          'comparison': comparison,
          'population': [
            {
              '@id': '_:pop1'
            }
          ],
          'gradeCertaintyOfEvidence': certaintyOfEvidence,
          'gradeCertaintyOfEvidenceLabel': gradeCertaintyOfEvidenceLabel,
          'perspective': perspective
        }
      ],
      'recommendation': {
        'coi': coi,
        'direction': recommendationDirection,
        'strength': recommendationStrength,
        'assessmentSummary': exportAssessmentSummary(recommendation),
        'conclusions': conclusions,
        'value': recommendationText
      },
      'diagnostic': isDiagnostic,
      'isofData': isofData,
      'etdPrintout': etdPrintout,
      'adapted': getRecommendationMetadata(recommendation, 'adapted', false)[0],
      "uniqueRecommendationCode": getRecommendationMetadataOrUndefined(recommendation, 'uniqueRecommendationCode'),
      'recommendationIntent': _.union(['all'], getRecommendationMetadata(recommendation, 'recommendationIntent')),
      'intendedPopulation': getRecommendationMetadata(recommendation, 'intendedPopulation'),
      'coexistingCondition': getRecommendationMetadataOrUndefined(recommendation, 'coexistingCondition'),
      'siteOfDisease': siteOfDisease,
      'evidenceTableLink': getRecommendationMetadataOrUndefined(recommendation, 'evidenceTableUrl'),
      'evidenceProfilePagesRangeGuideline': getRecommendationMetadataOrUndefined(recommendation, 'evidenceProfilePagesRangeGuideline'),
      'evidenceProfilePagesRangePDF': getRecommendationMetadataOrUndefined(recommendation, 'evidenceProfilePagesRangePDF'),
      'evidenceToDecisionUrl': getRecommendationMetadataOrUndefined(recommendation, 'evidenceToDecisionUrl'),
      'evidenceToDecisionPagesRangeGuideline': getRecommendationMetadataOrUndefined(recommendation, 'evidenceToDecisionPagesRangeGuideline'),
      'evidenceToDecisionPagesRangePDF': getRecommendationMetadataOrUndefined(recommendation, 'evidenceToDecisionPagesRangePDF'),
      'emlLink': getRecommendationMetadataOrUndefined(recommendation, 'emlUrl'),
      'additionalEvidenceTableUrl': getRecommendationMetadata(recommendation, 'additionalEvidenceTableUrl')
    };
  });
};

module.exports = exportQuestionAndRecommendation;
